

const REDIRECT_URL_KEY = 'redirectAfterLogin';


export const saveRedirectUrl = (pathname: string, search?: string): void => {
    if (typeof window === 'undefined') return;

    // Don't save login page or root as redirect URL
    if (pathname === '/' || pathname === '/login') return;

    const fullPath = search
        ? `${pathname}${search.startsWith('?') ? search : `?${search}`}`
        : pathname;
    sessionStorage.setItem(REDIRECT_URL_KEY, fullPath);
};


export const getAndClearRedirectUrl = (): string | null => {
    if (typeof window === 'undefined') return null;

    const savedUrl = sessionStorage.getItem(REDIRECT_URL_KEY);
    if (savedUrl) {
        sessionStorage.removeItem(REDIRECT_URL_KEY);
    }
    return savedUrl;
};


/**
 * Get the saved redirect URL without clearing it.
 * Useful for checking centerId before deciding whether to auto-select school.
 */
export const getRedirectUrl = (): string | null => {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(REDIRECT_URL_KEY);
};


export const extractPathname = (fullPath: string): string => {
    return fullPath.split('?')[0];
};


/**
 * Extract a specific query parameter from the saved redirect URL.
 * @param paramName - The query parameter name to extract (e.g., 'centerId')
 */
export const extractParamFromUrl = (fullPath: string, paramName: string): string | null => {
    if (!fullPath) return null;

    const queryString = fullPath.split('?')[1];
    if (!queryString) return null;

    const params = new URLSearchParams(queryString);
    return params.get(paramName);
};


/**
 * Get centerId from the saved redirect URL (if exists).
 * Does not clear the URL from sessionStorage.
 */
export const getCenterIdFromSavedUrl = (): string | null => {
    const savedUrl = getRedirectUrl();
    if (!savedUrl) return null;
    return extractParamFromUrl(savedUrl, 'centerId');
};


export const clearRedirectUrl = (): void => {
    if (typeof window === 'undefined') return;
    sessionStorage.removeItem(REDIRECT_URL_KEY);
};

export default {
    saveRedirectUrl,
    getAndClearRedirectUrl,
    getRedirectUrl,
    extractPathname,
    extractParamFromUrl,
    getCenterIdFromSavedUrl,
    clearRedirectUrl,
    REDIRECT_URL_KEY,
};
